module.exports = __webpack_public_path__ + "img/Freelancehunt.399b4255.webp";